import script from "./MultipleBets.vue?vue&type=script&setup=true&lang=js"
export * from "./MultipleBets.vue?vue&type=script&setup=true&lang=js"

import "./MultipleBets.vue?vue&type=style&index=0&id=1e84134e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e84134e"]])

export default __exports__